const HMR = "HMR";
const RMMR = "RMMR";

const $inject = [
  "AdminPharmacistService",
  "$scope",
  "data",
];

class PharmacistController {
  constructor(
    PharmacistService,
    $scope,
    data
  ) {
    this.PharmacistService = PharmacistService;
    this.$scope = $scope;
    $scope.data = data;
    this.original_data = angular.copy(data);
    this.facility_provider_id = data.pharmacist.facilityProvider && data.pharmacist.facilityProvider.id;
    this.facilities = {};
    this.saving = false;
  }

  //noinspection JSUnusedGlobalSymbols
  get_facility_tag_class(id, $tag, $index, $selected) {
    return !this.original_data.pharmacist.facilities.some(facility => facility.name === $tag.name) && !$selected;
  }

  //noinspection JSUnusedGlobalSymbols
  get_facility_tags(query) {
    let self = this;
    //noinspection JSUnusedLocalSymbols
    return new Promise(function (resolve, reject) {
      resolve(self.$scope.data.facilities.filter(facility => self.$scope.data.pharmacist.facilityProvider.id === facility.facilityProvider.id && facility.name.toLowerCase().includes(query.toLowerCase())));
    });
  }

  change_facility_provider() {
    let self = this;
    if (this.facility_provider_id) {
      this.facilities[this.facility_provider_id] = this.$scope.data.pharmacist.facilities.filter(facility => facility.facilityProvider.id === self.facility_provider_id);
    }
    this.facility_provider_id = this.$scope.data.pharmacist.facilityProvider && this.$scope.data.pharmacist.facilityProvider.id;

    this.$scope.data.pharmacist.facilities = [];
    if (this.facility_provider_id && this.facilities[this.facility_provider_id]) {
      this.$scope.data.pharmacist.facilities = this.facilities[this.facility_provider_id];
    }
  }

  update(form) {
    let self = this;
    this.submitted = true;

    function handleSuccess(response) {
      try {
        if (response.data.success) {
          self.$scope.data.pharmacist = response.data.data.pharmacist;
          self.$scope.data.pharmacist.status = self.$scope.data.statuses.find(status => status.id === self.$scope.data.pharmacist.status.id);
          self.$scope.data.pharmacist.facilityProvider = self.$scope.data.pharmacist.facilityProvider && self.$scope.data.facility_providers.find(facility_provider => facility_provider.id === self.$scope.data.pharmacist.facilityProvider.id);
          self.original_data.pharmacist = angular.copy(response.data.data.pharmacist);
          if (response.data.message) {
            self.$scope.show_toast(response.data.message, "alert-success");
          }
        }
        else {
          self.$scope.show_toast(response.data.message, "alert-danger");
        }
      }
      catch (e) {
        self.$scope.show_toast(e.toString(), "alert-warning");
      }
      self.saving = false;
    }

    function handleError(response) {
      self.$scope.show_toast(response.data.message, "alert-danger");
      self.saving = false;
    }

    if (form.$valid) {
      this.saving = true;
      this.PharmacistService.update(this.$scope.data.pharmacist, handleSuccess, handleError);
    }
  }

  other_products(product) {
    return ![HMR, RMMR].some(type => type === product.referral_type.code);
  }
}

PharmacistController.$inject = $inject;

export default PharmacistController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/pharmacist-edit.controller.js
 **/